/**
 * 产品id
 */
import { callbackProxy, getDocumentHeight, isClient, queryString, urlQueryString } from '../utils';
import { Log } from '../log';
import { appInfo } from '../appInfo';
import { isDef } from '../utils';
import { nativeProtocol, ProductId } from './protocol';
/**
 * 打开Native页面
 * @param path Native路由，可参考 https://192.168.7.6:5858/svn/EMAPP/doc/%E5%8D%8F%E8%AE%AE/%E5%86%85%E5%B5%8CWEB%E6%89%93%E5%BC%80Native%E9%A1%B5%E9%9D%A2%E8%B7%AF%E7%94%B1%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3.md
 */
export function openNative(path) {
    console.log('[openNative]: ' + path);
    if (typeof process !== 'undefined' &&
        process.env.NODE_ENV === 'development') {
        // 仅本地开发有效，防止阻塞热更新
        var iframeElm = document.createElement('iframe');
        iframeElm.style.display = 'none';
        iframeElm.src = path;
        document.body.appendChild(iframeElm);
    }
    else {
        location.href = path;
    }
}
/**
 * 保留当前页面，打开指定链接，
 * @param url 要打开的页面url，支持Native路由，如果url没有sourcePath，则自动截取当前页面的sourcePath并拼接到url中
 * @param data
 * @returns
 */
export function openurl(url, data) {
    if (!url) {
        console.error('请传入要打开的页面地址');
        return;
    }
    console.info('打开地址：', url, data || '');
    if (!/^https?/.test(url)) {
        openNative(url);
        return;
    }
    var sourcePath = Log.getSourcePath();
    if (sourcePath && !/sourcePath/i.test(url)) {
        url = urlQueryString.stringify(url, {
            sourcePath: sourcePath
        });
    }
    if (typeof window.goods !== 'undefined' && window.goods.openurl) {
        if (data) {
            window.goods.openurl(url, typeof data === 'string' ? data : JSON.stringify(data));
        }
        else {
            window.goods.openurl(url);
        }
    }
    else {
        var search = location.search;
        // let url = params.url;
        if (url.indexOf('?') > -1) {
            url = url + search.replace('?', '&');
        }
        else {
            url = url + search;
        }
        // 防止sourcePath被url覆盖
        if (sourcePath) {
            url = urlQueryString.stringify(url, {
                sourcePath: sourcePath
            });
        }
        // 使用原生打开失败时，尝试使用location直接跳转
        location.href = url;
    }
}
/**
 * 打开网页，适用于智盈、有看投
 */
export function openBrowser(options) {
    openNative(nativeProtocol + "://browser?" + queryString.stringify(options));
}
/**
 * 关闭当前页面（webview）
 */
export function goBack() {
    if (isClient && window.goods) {
        if (window.goods.goback) {
            window.goods.goback();
        }
        else if (window.goods.closeWebPage) {
            window.goods.closeWebPage();
        }
        else {
            console.info('goods.goback and goods.closeWebPage are undefined');
        }
    }
    else {
        console.warn('goods or goods.goback is undefined');
    }
}
/**
 * 轻提示（弹出类似于toast的提示框）
 * 网页关闭后仍能显示
 * @param text - 提示的内容
 */
export function showNotify(text) {
    if (isClient && window.goods) {
        if (window.goods.showNotify) {
            window.goods.showNotify(text);
        }
        else if (window.goods.showTips) {
            window.goods.showTips(text);
        }
        else {
            console.info('goods.showNotify and goods.showTips are undefined');
        }
    }
    else {
        console.info('goods or goods.showNotify is undefined');
    }
}
/**
 * 修改页面标题
 * 接修改title，ios设备不能自动刷新，需要调用客户端的方法进行更新
 * @param {string} title 标题
 */
export function updateTitle(title) {
    if (isClient) {
        document.title = title;
        // 直接修改title，ios设备不能自动刷新，需要调用客户端的方法进行更新
        if (window.goods && window.goods.updateTitle) {
            window.goods.updateTitle({ title: title });
        }
    }
}
/**
 * 显示右上角菜单
 * @param  options 菜单配置
 */
export function showMenuItems(options) {
    var menuItems = [];
    options.menuItems.forEach(function (item) { return menuItems.push(callbackProxy(item)); });
    if (isClient && window.goods && window.goods.showMenuItems) {
        console.info('[native] goods.showMenuItems', JSON.stringify({ menuItems: menuItems }));
        window.goods.showMenuItems(JSON.stringify({ menuItems: menuItems }));
    }
    else {
        console.info('[native] goods.showMenuItems is undefined', { menuItems: menuItems });
    }
}
/**
 * 在线客服(IM)
 * @param code 位置码例如：个人中心-客服-在线客服
 * @param title 页面标题  默认为在线客服
 */
export function openOnLineService(code, title) {
    var url = "skstock://onlineservice?code=" + encodeURIComponent(code);
    if (title) {
        url += "&title=" + encodeURIComponent(title);
    }
    openNative(url);
}
/**
 * 登录类型
 */
export var LoginType;
(function (LoginType) {
    /**
     * 微信
     */
    LoginType[LoginType["Wechat"] = 1] = "Wechat";
    /**
     * 手机号
     */
    LoginType[LoginType["Phone"] = 2] = "Phone";
})(LoginType || (LoginType = {}));
/**
 * 登录
 * @param type
 */
export function login(type) {
    if (type === void 0) { type = LoginType.Phone; }
    openNative(nativeProtocol + "://login?type=" + type + "&uitype=1");
}
/**
 * 绑定手机号
 */
export function bindPhone() {
    openNative(nativeProtocol + "://phonebind");
}
/**
 * 打开单个个股
 */
export function openStock(options) {
    var stockId = options.stockId, clName = options.clName, clDate = options.clDate, clId = options.clId;
    var openStocksOptions = {
        stockIds: [stockId],
        stockId: stockId
    };
    if (clName) {
        openStocksOptions.clNames = [clName];
    }
    if (clDate) {
        openStocksOptions.clDates = [clDate];
    }
    if (clId) {
        openStocksOptions.clIds = [clId];
    }
    openStocks(openStocksOptions);
}
/**
 * 打开多个个股，并打开策略小旗帜
 */
export function openStocks(options) {
    var stockIds = options.stockIds, stockId = options.stockId, clNames = options.clNames, clDates = options.clDates, clIds = options.clIds;
    if (stockIds && stockId) {
        var codeArray = [];
        codeArray = stockIds;
        // 确保为字符串数组
        var tempArray = [];
        for (var index = 0; index < codeArray.length; index++) {
            var element = codeArray[index];
            tempArray.push(element + '');
        }
        codeArray = tempArray;
        var codeIndex = codeArray.indexOf(stockId + '');
        var codes = codeArray.join(',');
        var url = 'skstock://stock?codes=' + codes;
        if (codeIndex > -1) {
            if (appInfo.productId === ProductId.Skstock &&
                appInfo.compareVersion('3.5.2') &&
                codeArray.every(function (id) { return id.toString().startsWith('2'); })) {
                url = 'skstock://sector-more?codes=' + codes + '&index=' + codeIndex;
            }
            else {
                url = 'skstock://stock?codes=' + codes + '&index=' + codeIndex;
            }
        }
        else {
            console.warn("\u8981\u6253\u5F00\u7684\u4E2A\u80A1stockId:" + stockId + "\u4E0D\u5728\u80A1\u7968\u5217\u8868stockIds:" + stockIds + "\u4E2D");
        }
        if (clNames) {
            url += "&clNames=" + clNames + "&fk=1";
        }
        if (clDates) {
            url += "&clDates=" + clDates;
        }
        if (clIds) {
            url += "&clIds=" + clIds;
        }
        openNative(url);
    }
}
/**
 * 页面高度变化时，通知app调整webview高度，个股下方的页面需要调用该方法
 * @param container 页面容器，为空时则获取文档高度
 */
export function onHeightChange(container) {
    setTimeout(function () {
        var currentHeight = 0;
        if (isDef(container)) {
            if (typeof container === 'string') {
                var el = document.querySelector(container);
                if (el) {
                    currentHeight = el.getBoundingClientRect().height;
                }
            }
            else if (typeof container === 'number') {
                currentHeight = container;
            }
        }
        else {
            currentHeight = getDocumentHeight();
        }
        if (isClient && window.goods && window.goods.onHeightChange) {
            console.info('[native] goods.onHeightChange: ', currentHeight);
            window.goods.onHeightChange(JSON.stringify({
                height: currentHeight
            }));
        }
        else {
            console.info('[native] goods.onHeightChange is undefined', currentHeight);
        }
    }, 500);
}
/**
 * 打开pdf文件
 * @param url pdf地址
 */
export function openPdf(url) {
    if (isClient && window.goods && window.goods.downloadPdf) {
        window.goods.downloadPdf(url);
    }
    else {
        openurl(url);
    }
}
export var ControlZxgType;
(function (ControlZxgType) {
    /**
     * 添加自选股
     */
    ControlZxgType[ControlZxgType["Add"] = 1] = "Add";
    /**
     * 删除自选股
     */
    ControlZxgType[ControlZxgType["Delete"] = 2] = "Delete";
})(ControlZxgType || (ControlZxgType = {}));
/**
 * 添加/删除 自选股
 */
export function controlZxg(options) {
    if (window.goods && window.goods.controlZxg) {
        window.goods.controlZxg(JSON.stringify(callbackProxy(options)));
    }
    else {
        console.info('goods or goods.controlZxg is undefined');
    }
}
/**
 * 是否已添加到自选股
 * @param options
 */
export function isGoodsAddedZxg(options) {
    if (window.goods && window.goods.isGoodsAddedZxg) {
        window.goods.isGoodsAddedZxg(JSON.stringify(callbackProxy(options)));
    }
    else {
        console.info('goods or goods.isGoodsAddedZxg is undefined');
    }
}
/**
 * 分享类型
 */
export var ShareType;
(function (ShareType) {
    /**
     * 微信
     */
    ShareType[ShareType["Wechat"] = 1] = "Wechat";
    /**
     * 新浪微博
     */
    ShareType[ShareType["Weibo"] = 2] = "Weibo";
    /**
     * 微信朋友圈
     */
    ShareType[ShareType["WechatTimeline"] = 4] = "WechatTimeline";
    /**
     * QQ好友
     */
    ShareType[ShareType["QQ"] = 5] = "QQ";
})(ShareType || (ShareType = {}));
/**
 * 分享
 */
export function share(options) {
    var content = options.content || '';
    // 去除html标签
    content = content.replace(/<[^>]+>/g, '');
    content = content.replace(/&nbsp;/g, '');
    content = content.replace(/&quot;/g, '');
    content = content.replace(/Result=/, '');
    if (content && content.length > 100) {
        content = content.substr(0, 100) + '....';
    }
    var optionsProxy = callbackProxy(options);
    console.info('[@em/ym]: share-', optionsProxy);
    if (window.goods && window.goods.share) {
        window.goods.share(options.title, options.url, options.type, options.imageUrl || '', '', content, '', optionsProxy.callbackParams);
    }
    else {
        console.info('goods or goods.share is undefined');
    }
}
//# sourceMappingURL=common.js.map